import { Component, Input, ViewChild, ElementRef, ContentChild, TemplateRef  } from '@angular/core';
import { RmtVirtualScrollComponent } from '../rmt-virtual-scroll/rmt-virtual-scroll';
import * as $ from 'jquery'

@Component({
  selector: 'rmt-virtual-scroll-item',
  templateUrl: 'rmt-virtual-scroll-item.html'
})
export class RmtVirtualScrollItemComponent {
  /* 
    we are using ng-template here as a work around an issue in angular 5 where the ng-content get rendered even if wrapped in *ngIf false
    https://stackoverflow.com/questions/44929726/angular4-ng-content-gets-built-when-ngif-is-false
  */  
  @ContentChild(TemplateRef) detailRef; 
  @ViewChild('container', { read: ElementRef }) container;
  @Input() height: string = 'auto';
  @Input() condition: boolean = true;
  prevCondition: boolean = this.condition;
  render: boolean = false;

  static initTimeout = false;
  static initItems = [];
  static changesTimeout = null;
  static changesItems = [];
  static pendingTimeout = null;
  static pendingItems = [];

  constructor() {
  }  

  ngAfterViewInit() {    
    if (this.container) {
      const parent = this.container.nativeElement.parentNode;      
      parent.callbackRender = (init) => {
        if (this.render) {
          parent.callbackRender = null;
          return;
        }
        if (init) {
          // don't use setTimeout otherwise it can flicker when reloading
          RmtVirtualScrollItemComponent.initItems.push(this);
          if (!RmtVirtualScrollItemComponent.initTimeout) {
            RmtVirtualScrollItemComponent.initTimeout = true;
            window.requestAnimationFrame(() => {
              RmtVirtualScrollItemComponent.initTimeout = false;
              for (let i=0; i < RmtVirtualScrollItemComponent.initItems.length; i++) {
                const item = RmtVirtualScrollItemComponent.initItems[i];
                item.container.nativeElement.parentNode.callbackRender = null;
                item.render = true;
              }
              RmtVirtualScrollItemComponent.initItems = [];
            });
          }
          return;          
        }

        RmtVirtualScrollItemComponent.pendingItems.push(this);
        if (!RmtVirtualScrollItemComponent.pendingTimeout)
          RmtVirtualScrollItemComponent.pendingTimeout = window.setTimeout(() => {
            RmtVirtualScrollItemComponent.pendingTimeout = null;
            for (let i=0; i < RmtVirtualScrollItemComponent.pendingItems.length; i++) {
              const item = RmtVirtualScrollItemComponent.pendingItems[i];
              const node = item.container.nativeElement.parentNode;
              const child = item.container.nativeElement.getElementsByClassName('virtual-item-content');
              if (child && child.length > 0 && child[0].style.display !== 'none') {
                item.render = true;
                node.style.transition = '100ms linear opacity';
                node.callbackRender = null;
              }
            }
            RmtVirtualScrollItemComponent.pendingItems = [];
          }, 100);
      };
      let init = false;
      const scrolls = $(this.container.nativeElement).parents('rmt-virtual-scroll');
      if (scrolls && scrolls.length > 0) {
        const childs = scrolls[0].getElementsByTagName('rmt-virtual-scroll-item');
        for (let i = 0; i < childs.length; i++) {
          if (childs[i] === parent) {
            init = true;
            break;
          }
          if (i > 20)
            break;
        }
      }
      this.update(init);
    }
  }

  update(init: boolean = false) {
    const scrolls = $(this.container.nativeElement).parents('.scroll-content');
    if (!scrolls || scrolls.length === 0)
      return;

    const scroll = scrolls.get(0);
    RmtVirtualScrollComponent.checkItem(this.container.nativeElement.parentNode, scroll, init);
  }

  ngOnChanges() {
    if (this.condition !== this.prevCondition) {
      this.prevCondition = this.condition;
      RmtVirtualScrollItemComponent.changesItems.push(this);
      if (!RmtVirtualScrollItemComponent.changesTimeout)
        RmtVirtualScrollItemComponent.changesTimeout = window.setTimeout(() => {
          RmtVirtualScrollItemComponent.changesTimeout = null;
          for (let i=0; i < RmtVirtualScrollItemComponent.changesItems.length; i++) {
            const item = RmtVirtualScrollItemComponent.changesItems[i];
            if (item.condition)
              item.render = true;
            if (item.container)
              item.update();
          }
          RmtVirtualScrollItemComponent.changesItems = [];
        });
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/rmt-virtual-scroll-item/rmt-virtual-scroll-item.ts